"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Note that as a best practice the "core" package should not have dependencies.
// This will have to be moved to his own package.
var objects_1 = require("@radar-ui/objects");
/**
 * Function to retrieve a value from the SC theme props. Requires a path and supports a localTheme
 * useful for developing radar-ui packages with a local theme.
 *
 * The benefit of having a local theme per package instead of polluting the radar-ui core config
 * is that for every change we dcon't need to publish all the packages.
 */
var theme = function (path, localTheme) {
    if (localTheme === void 0) { localTheme = {}; }
    return function (props) {
        var value = (0, objects_1.get)(props.theme, path) || (0, objects_1.get)(localTheme, path);
        if (value === undefined) {
            throw new Error("".concat(path, " seems not to be defined in you theme object"));
        }
        return value;
    };
};
exports.default = theme;
//# sourceMappingURL=theme.js.map